import { api, toQuery } from "./client";
import type { Note } from "../lib/types";

export function listNotes(filters: { keyword?: string } = {}) {
  return api<{ notes: Note[] }>(`/api/v1/notes${toQuery(filters)}`);
}

export function createNote() {
  return api<Note>("/api/v1/notes", { method: "POST" });
}

export function updateNote(id: string, patch: { title: string; content_html: string }) {
  return api<Note>(`/api/v1/notes/${id}`, {
    method: "PUT",
    body: JSON.stringify(patch)
  });
}

export function deleteNote(id: string) {
  return api<{ message: string }>(`/api/v1/notes/${id}`, { method: "DELETE" });
}
